import { Button, Icon, LinkButton, Tooltip, Typography } from "@/components/atoms";
import { Breadcrumbs } from "@/components/atoms";
import { usePage } from "@/hooks";
import { clsx } from "@/utils";
import { isEmpty } from "ramda";

export interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  skipCrumbs?: number;
  moreCrumbs?: {
    name: string;
    to: string;
    current: boolean;
  }[];
  info?: string;
}

export const PageHeader = ({ className, title, skipCrumbs = 0, moreCrumbs = [], info, children }: PageHeaderProps) => {
  const { pages } = usePage();

  const splicedPages = [...pages, ...moreCrumbs].splice(skipCrumbs);

  return (
    <header className={clsx("sticky top-0 z-20 -mx-4 bg-white px-5 py-3", className)}>
      <hgroup className="flex items-center">
        <div className="flex flex-row items-center gap-x-1.5">
          <Typography variant="h2" className="inline-flex">
            {title || pages?.[0].name}
          </Typography>
          {info && isEmpty(moreCrumbs) && (
            <Tooltip content={info} placement="right">
              <span>
                <Icon name="InfoCircle" variant="Bold" className="rotate-180 text-neutral-dark-gray" size="lg" />
              </span>
            </Tooltip>
          )}
        </div>
        <Breadcrumbs
          className={clsx("ml-4 h-6 border-solid border-neutral-mid-gray px-2", splicedPages.length > 0 && " border-l")}
          pages={splicedPages}
        />
      </hgroup>
      {children}
    </header>
  );
};

interface ActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  prevPage?: string;
  onBack?: () => void;
}

const Actions = ({ prevPage, onBack, children, className }: ActionsProps) => {
  return (
    <div className={clsx("flex justify-between bg-white pb-3", className)}>
      {onBack ? (
        <Button onClick={onBack} startIcon="ArrowLeft" variant="secondary" className="bg-transparent" size="sm">
          Back
        </Button>
      ) : (
        <LinkButton to={prevPage ?? "../"} startIcon="ArrowLeft" variant="secondary" className="bg-transparent" size="sm">
          Back
        </LinkButton>
      )}
      {children}
    </div>
  );
};

PageHeader.Actions = Actions;
